<template>
  <div class="pb100">
    <crumbs detail="true"/>
    <div class="container">
      <div class="detailmodel1 clearfix">
        <div class="leftcon fl">
          <h2 class="title">{{ appointmentdetail.name }}</h2>
          <div class="imgtxtbox clearfix">
            <div class="imgbox fl">
              <div class="imgboxinner">
                <i class="icon-scale1"></i>
                <img class="imgtop" preview="0" :src="getImage(appointmentdetail.image)" alt="">
              </div>
              <div class="labelbox">
                <el-button size="small" round
                           v-show="appointmentdetail.businessTypeList && appointmentdetail.businessTypeList.length > 0"
                           v-for="(item, index) in appointmentdetail.businessTypeList"
                           :key="index">{{ item }}</el-button>
              </div>
            </div>
            <div class="txtbox fr">
              <div class="con_detail">
                <p class="icon icon1" v-show="appointmentdetail.number !== 0">{{ surplusname }}<em class="red">{{ appointmentdetail.surplus }}</em>{{ unit }}/共<em class="blue">{{ appointmentdetail.number }}</em>{{ unit }}</p>
                <p class="icon icon2">{{ feename }}<em class="red">{{ appointmentdetail.price }}</em></p>
                <p class="icon icon3" onclick="fnDaohang('35.474312','118.04832', appointmentdetail.address);">{{ appointmentdetail.address }}</p>
                <p class="icon icon4">
                  <input type="text" :value="getTime(appointmentdetail.enrollBeginTime)" disabled="disabled">
                  <input type="text" :value="getTime(appointmentdetail.enrollEndTime)" disabled="disabled">
                </p>
                <p class="icon icon4">
                  <input type="text" :value="getTime(appointmentdetail.beginTime)" disabled="disabled">
                  <input type="text" :value="getTime(appointmentdetail.endTime)" disabled="disabled">
                </p>
                <p class="icon icon5" v-show="appointmentdetail.phone !== undefined && appointmentdetail.phone !== ''">{{ appointmentdetail.phone }}</p>
                <p class="icon icon6" v-show="appointmentdetail.organizer !== undefined && appointmentdetail.organizer !== ''">{{ appointmentdetail.organizer }}主办</p>
                <p class="icon icon6" v-show="appointmentdetail.coOrganizer !== undefined && appointmentdetail.coOrganizer !== ''">{{ appointmentdetail.coOrganizer }}协办</p>
                <p class="icon icon6" v-show="appointmentdetail.contractor !== undefined && appointmentdetail.contractor !== ''">{{ appointmentdetail.contractor }}承办</p>
                <p class="icon icon6" v-show="appointmentdetail.sponsor !== undefined && appointmentdetail.sponsor !== ''">{{ appointmentdetail.sponsor }}赞助</p>
                <div class="btnbox clearfix" v-if="appointmentdetail.number !== 0">
                  <el-button type="warning" round v-if="appointmentdetail.enrollStatus && appointmentdetail.enrollStatus.code === 0">报名未开始</el-button>
                  <el-button type="primary" round @click="enrollfun" v-else-if="appointmentdetail.enrollStatus && appointmentdetail.enrollStatus.code === 1">活动报名</el-button>
                  <el-button type="info" round v-else>报名已结束</el-button>
                </div>
                <div class="btnbox clearfix" v-else>
                  <el-button round>直接前往</el-button>
                </div>
              </div>
            </div>
          </div>
          <div class="tipsbox" v-show="appointmentdetail.tip1Id !== undefined">
            <h3>{{ appointmentdetail.tip1Name }}</h3>
            <div class="txt" v-html="appointmentdetail.tip1Value"></div>
          </div>
          <div class="contentbox" v-html="appointmentdetail.content"></div>
          <comment v-if="appointmentdetail" @commentcount="commentCount" @coffsettop="cOffsettop" v-show="isCommentshow"></comment>
        </div>
        <div class="rightcon fr">
          <h2 class="title">推荐活动</h2>
          <ul v-if="recommend && recommend.length > 0">
            <li v-for="(item, index) in recommend" :key="index" @click.stop="detaillink(item.columnId, item.id)">
              <a>
                <div class="imgbox">
                  <img class="imgtop" :src="getImage(item.image)" alt="">
                </div>
                <h4 class="textover">{{ item.name }}</h4>
              </a>
            </li>
          </ul>
          <h2 class="nodata mt20 mb20" v-if="noData">暂无数据</h2>
        </div>
      </div>
    </div>
    <go-top></go-top>
    <right-sidebar
      :comment-count="commentTotal"
      :comment-gotop="commentOffsettop"
      :comment-show="isCommentshow"
      :title="appointmentdetail.name"
      :image="getImage(appointmentdetail.image)"
      :url="this.$route.fullPath"
      ref="rightSidebar"></right-sidebar>
  </div>
</template>

<script>
import Vue from 'vue'
import { timeFormat } from '@/utils/validate'
import { getAppointmentDetail } from '@/api/appointment/index'
import crumbs from '@/components/crumbs/index'
import goTop from '@/components/gotop/index'
import RightSidebar from '@/components/rightsidebar/index'
import Comment from '@/components/comment/index'
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
Vue.use(preview)
export default {
  name: 'appointmentdetail',
  meta: {
    showHeader: true
  },
  components: {
    crumbs,
    goTop,
    RightSidebar,
    Comment
  },
  data () {
    return {
      slotList: [],
      surplusname: '余票',
      allname: '总票数',
      unit: '张',
      feename: '票价',
      noData: false,
      recommend: [],
      appointmentdetail: '',
      commentTotal: '',
      commentOffsettop: '',
      isCommentshow: true // 是否显示评论
    }
  },
  computed: {
    adSlot () {
      return this.$store.state.adSlot.list
    }
  },
  watch: {
    adSlot (val) {
      if (val) {
        this.slotList = val
        this.getData()
      }
    }
  },
  mounted () {
    this.getDetail()
    if (this.$store.state.adSlot.list.length !== 0) {
      this.slotList = this.$store.state.adSlot.list
      this.getData()
    }
  },
  methods: {
    getData () {
      this.slotList.forEach(item => {
        if (item.slotName === 'ticketText') {
          item.adDetails.forEach(items => {
            if (parseInt(items.adLink) === parseInt(this.$route.query.columnId) && items.adCode === 'surplus') {
              this.surplusname = items.adName
            }
            if (parseInt(items.adLink) === parseInt(this.$route.query.columnId) && items.adCode === 'allname') {
              this.allname = items.adName
            }
            if (parseInt(items.adLink) === parseInt(this.$route.query.columnId) && items.adCode === 'unit') {
              this.unit = items.adName
            }
            if (parseInt(items.adLink) === parseInt(this.$route.query.columnId) && items.adCode === 'feename') {
              this.feename = items.adName
            }
          })
        }
      })
    },
    /* 评论总数 */
    commentCount (val) {
      this.commentTotal = val
    },
    /* 评论距顶部距离 */
    cOffsettop (val) {
      this.commentOffsettop = val
    },
    getTime (val) {
      return timeFormat(val, 'yymmddhhmm')
    },
    getImage (val) {
      if (val === undefined) {
        return require('@/assets/common/images/default.png')
      } else {
        return val
      }
    },
    getDetail () {
      getAppointmentDetail(this.$route.query.id).then(res => {
        if (res.data.status === 200) {
          this.appointmentdetail = res.data.data
          this.recommend = res.data.data.recommendList
          if (this.recommend.length === 0) this.noData = true
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    detaillink (columnId, id) {
      this.$router.push({path: '/appointmentdetail', query: {columnId: columnId, id: id}})
    },
    enrollfun () {
      this.$router.push({path: '/appointmentenroll', query: {columnId: this.$route.query.columnId, id: this.$route.query.id}})
    }
  }
}
</script>

<style lang="scss" scoped>
  .appointmentcontainer{
    padding: 0 0 100px;
  }
</style>



// WEBPACK FOOTER //
// src/view/appointment/detail.vue